// Shared reference data for the Notice Manager UI. Curated notice-type lists
// per regime — these are the common heads a CA firm sees. Free text is still
// allowed (the Select falls back to an "Other" text input), so an unusual
// notice type is never blocked.

export const REGIMES = [
  { value: 'income_tax', label: 'Income Tax' },
  { value: 'gst', label: 'GST' },
];

export const NOTICE_TYPES = {
  income_tax: [
    { code: '143(1)', desc: 'Intimation after processing' },
    { code: '139(9)', desc: 'Defective return' },
    { code: '142(1)', desc: 'Inquiry before assessment' },
    { code: '143(2)', desc: 'Scrutiny' },
    { code: '148', desc: 'Income escaping assessment' },
    { code: '156', desc: 'Notice of demand' },
    { code: '245', desc: 'Adjustment of refund' },
    { code: '133(6)', desc: 'Call for information' },
    { code: '270A', desc: 'Penalty' },
    { code: '271', desc: 'Penalty' },
  ],
  gst: [
    { code: 'GSTR-3A', desc: 'Return not filed' },
    { code: 'ASMT-10', desc: 'Scrutiny of returns' },
    { code: 'DRC-01A', desc: 'Intimation of tax ascertained' },
    { code: 'DRC-01', desc: 'Show cause notice' },
    { code: 'DRC-03', desc: 'Voluntary payment' },
    { code: 'ADT-01', desc: 'Audit notice' },
    { code: 'REG-03', desc: 'Registration query' },
    { code: 'RFD-08', desc: 'Refund show cause' },
  ],
};

export const STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'under_review', label: 'Under Review' },
  { value: 'response_drafted', label: 'Response Drafted' },
  { value: 'responded', label: 'Responded' },
  { value: 'closed', label: 'Closed' },
  { value: 'escalated', label: 'Escalated' },
];

export const PRIORITIES = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'urgent', label: 'Urgent' },
];

export const statusLabel = (v) => STATUSES.find((s) => s.value === v)?.label || v;
export const regimeLabel = (v) => REGIMES.find((r) => r.value === v)?.label || v;
